module.exports = __webpack_public_path__ + "img/majesticons_file-plus-line.80e372d3.svg";